// Presentation for a call's dialer mode. Mirrors the labels used in the lead
// details activity timeline (Power Dialer / Multi-Line / Manual) so a call
// reads the same everywhere. The backend derives the mode from
// predictive_session_id / was_predialed (power), session_calls link (multi-line),
// else manual — see /communication/calls.
export type DialerMode = "manual" | "power_dialer" | "multi_line";

export function getDialerModeMeta(mode?: DialerMode | string | null): {
  label: string;
  className: string;
} {
  switch (mode) {
    // Colors match the lead timeline + Calls tab chips (violet/blue/gray) so a
    // call's dial method reads identically on every surface.
    case "power_dialer":
      return {
        label: "Power Dialer",
        className: "bg-violet-50 text-violet-700 border-violet-200",
      };
    case "multi_line":
      return {
        label: "Multi-Line",
        className: "bg-blue-50 text-blue-700 border-blue-200",
      };
    default:
      return {
        label: "Manual",
        className: "bg-gray-100 text-gray-600 border-gray-200",
      };
  }
}
